import "antd/dist/antd.css";
import "../../App.scss";

/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";

import { Layout } from "antd";
import qs from "qs";
import { useHistory, useLocation } from "react-router-dom";

import { DEFAULT_DASHBOARD_ROUTE } from "../../routeConstants";
import DashboardRouter from "../../Router";
import Footer from "../../ThemeComponents/Footer/Footer";
import Header from "../../ThemeComponents/Header/Header";
import Sider from "../../ThemeComponents/Sider/Sider";
import Loader from "../../Utils/Loader";
import { getRestrictionStatus } from "../api/index";

const loaderStyle = {
  position: "fixed",
  top: "45%",
  left: "45%",
  zIndex: 9999,
};

function DashboardIndex({
  isRestricted,
  setIsRestricted,
  allowedFunctions,
  setAllowedFunctions,
  sensitiveAllowedActions,
  setSensitiveAllowedActions,
}) {
  const history = useHistory();
  const location = useLocation();

  const [sliderValue, setSliderValue] = useState(
    isRestricted ? allowedFunctions[0] : "home"
  );
  const [loader, setLoader] = useState(false);

  useEffect(async () => {
    try {
      if (isRestricted) return false;
      setLoader(true);
      const resp = await getRestrictionStatus();
      if (resp.code === 0) {
        if (resp.result?.isRestricted) {
          setIsRestricted(true);
          setAllowedFunctions(resp.result?.allowedFunctions || []);
        }
        setSensitiveAllowedActions(resp.result?.sensitiveAllowedActions || []);
      } else {
        console.log(resp);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  }, []);

  useEffect(() => {
    const { userId, orderPage, userDetailsList } = qs.parse(
      history.location.search.slice(1)
    );

    // Handle legacy query parameter navigation
    if (userId) {
      history.replace(`/dashboard/user-details/${userId}`);
      return;
    }

    if (orderPage === "true") {
      history.replace("/dashboard/order-details");
      return;
    }

    if (userDetailsList === "true") {
      history.replace("/dashboard/user-details-list");
    }
  }, [history.location.search]);

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      history.push("/login");
    } else if (location.pathname === "/dashboard") {
      // Redirect to default dashboard route if accessing /dashboard exactly
      history.replace(DEFAULT_DASHBOARD_ROUTE);
    }
  }, [location.pathname, history]);

  return (
    <>
      {loader ? (
        <Loader style={loaderStyle} />
      ) : (
        <Layout>
          <Sider
            setSliderValue={setSliderValue}
            sliderValue={sliderValue}
            isRestricted={isRestricted}
            allowedFunctions={allowedFunctions}
          />
          <Layout className="siteLayout">
            <Header />
            <Layout.Content className="siteContent">
              <div className="siteDashboard">
                <DashboardRouter
                  isRestricted={isRestricted}
                  allowedFunctions={allowedFunctions}
                  sensitiveAllowedActions={sensitiveAllowedActions}
                  setSliderValue={setSliderValue}
                />
              </div>
            </Layout.Content>
            <Footer />
          </Layout>
        </Layout>
      )}
    </>
  );
}

export default DashboardIndex;
